module.exports = {
  "dateRange": function dateRange(args) {
    return "Od ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "Vybrat\xFD d\xE1tum ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "Kliknut\xEDm dokon\u010D\xEDte v\xFDber rozsahu d\xE1tumov",
  "maximumDate": "Posledn\xFD dostupn\xFD d\xE1tum",
  "minimumDate": "Prv\xFD dostupn\xFD d\xE1tum",
  "next": "Nasleduj\xFAce",
  "previous": "Predch\xE1dzaj\xFAce",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Vybrat\xFD d\xE1tum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Vybrat\xFD rozsah: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknut\xEDm spust\xEDte v\xFDber rozsahu d\xE1tumov",
  "todayDate": function todayDate(args) {
    return "Dnes ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Vybrat\xFD dne\u0161n\xFD d\xE1tum ".concat(args.date);
  }
};